import { SvgIcon, SvgIconProps } from '@mui/material';

const MoreVertFilledIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width='4'
        height='14'
        viewBox='0 0 4 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M2 3.66634C2.91667 3.66634 3.66667 2.91634 3.66667 1.99967C3.66667 1.08301 2.91667 0.333008 2 0.333008C1.08333 0.333008 0.333333 1.08301 0.333333 1.99967C0.333333 2.91634 1.08333 3.66634 2 3.66634ZM2 5.33301C1.08333 5.33301 0.333333 6.08301 0.333333 6.99967C0.333333 7.91634 1.08333 8.66634 2 8.66634C2.91667 8.66634 3.66667 7.91634 3.66667 6.99967C3.66667 6.08301 2.91667 5.33301 2 5.33301ZM2 10.333C1.08333 10.333 0.333333 11.083 0.333333 11.9997C0.333333 12.9163 1.08333 13.6663 2 13.6663C2.91667 13.6663 3.66667 12.9163 3.66667 11.9997C3.66667 11.083 2.91667 10.333 2 10.333Z'
          fill='black'
          fillOpacity='0.56'
        />
      </svg>
    </SvgIcon>
  );
};

export default MoreVertFilledIcon;
